import {
  put,
  fork,
  takeLatest
} from 'redux-saga/effects';
import { browserHistory } from 'react-router';
import {
  LOAD_CONTENT,
  DL_PAGE_LOADED
} from './redirect';
import {
  navigationRoutes,
  navigationSteps
} from '../../../navigation/navigationHelpers';

// WATCHERS
export function* loadContentWatch() {
  yield takeLatest(LOAD_CONTENT, loadContentWorker);
}

// WORKERS
export function* loadContentWorker() {
  try {
    yield put({
      type: DL_PAGE_LOADED
    });

  } catch(e) {
    browserHistory.push(navigationRoutes[navigationSteps.quickCheckout.ERROR].path);
  }
}

export default function* redirectSagas() {
  yield [
    fork(loadContentWatch)
  ];
}



/** WEBPACK FOOTER **
 ** ./client/redux/modules/pages/QuickCheckout/redirect/redirectSagas.js
 **/